import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { PrismicRichText, PrismicLink } from '@prismicio/react'

const IconDeck = ({ slice }) => {
  var numberOfCards = slice.items.length
  var gridClass = ''
  if (numberOfCards > 4) {
    gridClass = 'md:grid-cols-4'
  } else if (numberOfCards === 4) {
    gridClass = 'md:grid-cols-2 lg:grid-cols-4'
  } else {
    gridClass = 'md:grid-cols-' + numberOfCards
  }

  return (
    <section className='component-icon_deck mx-auto max-w-screen-xl p-6'>
      {slice.primary.deck_title.richText && (
        <div className='prose prose-lg mb-10 min-w-full text-center'>
          <PrismicRichText field={slice.primary.deck_title.richText} />
        </div>
      )}
      <ul className={`grid grid-cols-1 gap-5 lg:gap-10 ${gridClass}`}>
        {slice.items.map((iconCard, index) => {
          return (
            <li
              key={`icons-${index}`}
              className={`component-iconCard flex flex-col overflow-hidden rounded-lg bg-white shadow-md ${
                iconCard.button_link?.url && 'ease group relative transform transition duration-300 hover:scale-105 hover:shadow-lg'
              }`}>
              <div className='flex flex-1 flex-col p-6'>
                {iconCard.image.gatsbyImageData && <GatsbyImage className='mb-5 h-auto w-16' image={iconCard.image.gatsbyImageData} alt={iconCard.image.alt || ''} />}
                {iconCard.title && (
                  <div className='prose mb-3 uppercase tracking-wider text-primary'>
                    <PrismicRichText field={iconCard.title.richText} />
                  </div>
                )}
                {iconCard.text.richText && (
                  <div className='prose prose-lg leading-snug text-gray-500'>
                    <PrismicRichText field={iconCard.text.richText} />
                  </div>
                )}
                {iconCard.button_link?.url && (
                  <PrismicLink className='link mt-auto block pt-8 text-primary group-hover:text-primaryHover' href={iconCard.button_link.url}>
                    {iconCard.button_text && (
                      <span>
                        {iconCard.button_text}
                        <span className='inline-block transform transition duration-150 hover:translate-x-full'>→</span>
                      </span>
                    )}
                  </PrismicLink>
                )}
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}

export default IconDeck
